import { AiOutlineMobile } from "react-icons/ai";
import { VscDashboard } from "react-icons/vsc";
import { MdOutlineWeb } from "react-icons/md";
import { BsFonts } from "react-icons/bs";
import { IoGiftOutline } from "react-icons/io5";
import Mobile from '../assets/HomeIcons/IconsWhite/Mobile-phone (1).png'
import Dashboard from '../assets/HomeIcons/IconsWhite/Dashboard (1).png'
import Fonts from '../assets/HomeIcons/IconsWhite/Fonts.png'
import Templates from '../assets/HomeIcons/IconsWhite/Template (2).png'
import Freebies from '../assets/HomeIcons/IconsWhite/Freebies.png'
import MobileSVG from "../utils/Icons/MobileSVG";
import DashboardSVG from "../utils/Icons/DashboardSVG";
import TemplateSVG from "../utils/Icons/TemplateSVG";
import FontsSVG from "../utils/Icons/FontsSVG";
import FreebieesSVG from "../utils/Icons/FreeBieesSVG";

const fillColor = localStorage.getItem('dark') ?  '#C7C7C7' : '#6c6c6c' ; // black for light theme, white for dark theme


const homepageData = [
  { title: "Onboarding (16)", description: 'Guide your users to get started smoothly.' },
  { title: "Filtering (7)", description: 'Allow users to make the right choices.' },
  { title: "Profile (24)", description: 'Guide your users to get started smoothly.' },
  { title: "Checkout (7)", description: 'Let users edit personal info with ease ' },
  { title: "Upgrade Membership (4)", description: 'Guide your users to get started smoothly.' },
  { title: "Booking (8)", description: 'Allow users to make the right choices' },
  { title: "Transfering Operations (7)", description: 'Let users edit personal info with ease ' },
  { title: "Date Ranges & History (4)", description: 'Guide your users to get started smoothly.' },
];

const categories = [
  {
    category: 'Mobile UI Kits',
    icon: <MobileSVG stroke={fillColor} fill={fillColor}/>,
    styles: 'grid md:grid-cols-3 lg:grid-cols-4',
    cards: [
      {
        picture: 'https://cdn.dribbble.com/userupload/11623012/file/original-71b45a1f7d5758910892e6f7b6399df7.jpg?resize=1024x768',
        header: 'Modern Mobile UI Kit',
        user: {
          name: 'Jessica B.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$24.99',
      },
      {
        picture: 'https://cdn.dribbble.com/users/4710151/screenshots/19846167/media/8fc6fecbe7185a62978366fa16c22a6c.png?resize=1000x750&vertical=center',
        header: 'Clean UI Kit',
        user: {
          name: 'Mark L.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$34.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/4247022/file/original-d710592e7f465eb7bc2f00f89fad668a.png?resize=1024x789',
        header: 'Sleek Mobile UI Kit',
        user: {
          name: 'Jessica B.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$24.99',
      },
      {
        picture: 'https://cdn.dribbble.com/users/6252196/screenshots/15334182/media/7acdd2855c8b0a5c7cd473c54c06843b.png?resize=1000x750&vertical=center',
        header: 'Elegant UI Kit',
        user: {
          name: 'Mark L.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$34.99',
      },
      {
        picture: 'https://cdn.dribbble.com/users/508588/screenshots/14746649/media/0dafe03906c0dcf5024b6f123b156fd5.jpg?resize=1000x750&vertical=center',
        header: 'Premium UI Kit',
        user: {
          name: 'Jessica B.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$24.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/8621957/file/original-e23aacc11fb6edfbefd2be771c766125.jpg?resize=1024x766',
        header: 'Ultimate UI Kit',
        user: {
          name: 'Mark L.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$34.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/9100686/file/original-abbf96c02dd3300741bc888cab530a11.jpg?resize=1024x766',
        header: 'Sophisticated UI Kit',
        user: {
          name: 'Jessica B.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$24.99',
      },
      {
        picture: 'https://cdn.dribbble.com/users/508588/screenshots/14542352/media/a7f2ac5c597b0d322947627e89789976.jpg?resize=1000x750&vertical=center',
        header: 'Innovative UI Kit',
        user: {
          name: 'Mark L.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$34.99',
      },
    ],
  },
  {
    category: 'Dashboards & Admin Panels',
    icon: <DashboardSVG fill={fillColor} stroke={fillColor}/>,
    styles: 'grid lg:grid-cols-3',
    cards: [
      {
        picture: 'https://cdn.dribbble.com/userupload/13127588/file/original-ccac75f53e4ed86763a73544e0048e07.png?resize=1024x768',
        header: 'Admin Dashboard 1',
        user: {
          name: 'Alice K.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$44.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/7390122/file/original-f0a51857256dd5802cfc7a47a6f070a2.png?resize=1024x768',
        header: 'Admin Dashboard 2',
        user: {
          name: 'Alice K.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$44.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/14786373/file/original-0929624187623bd69827cdaed343d9e9.png?resize=1024x768',
        header: 'Advanced Dashboard',
        user: {
          name: 'Bob R.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$54.99',
      },
    ],
  },
  {
    category: 'Web Themes & Templates',
    icon: <TemplateSVG  stroke={fillColor}/>,
    styles: 'grid lg:grid-cols-3',
    cards: [
      {
        picture: 'https://cdn.dribbble.com/userupload/15356218/file/original-b70b6030ef51efbc9da5050593cff59b.png?resize=1024x768',
        header: 'Business Theme 1',
        user: {
          name: 'Eve N.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$49.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/15210535/file/original-6c65c2a5818285cc8f525558ee9ed875.png?resize=1024x768',
        header: 'Corporate Template',
        user: {
          name: 'Eve N.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$49.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/14096711/file/original-607d5717c05a6f8e04c135df3ff0c016.png?resize=1024x768',
        header: 'Creative Template',
        user: {
          name: 'Frank T.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$59.99',
      },
    ],
  },
  {
    category: 'Fonts',
    icon: <FontsSVG fill={fillColor} stroke={fillColor}/>,
    styles: 'grid lg:grid-cols-4',
    cards: [
      {
        picture: 'https://cdn.dribbble.com/userupload/12097893/file/original-575e0a7ed5f2f06c86ce832404116a6f.jpg?resize=1024x682',
        header: 'Elegant Font 1',
        user: {
          name: 'George W.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$12.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/9266415/file/original-3c25becd60cde4b58fe66259a08e33a5.jpg?resize=1024x683',
        header: 'Stylish Font 2',
        user: {
          name: 'Hannah Y.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$17.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/9606521/file/original-fb63254c9e42c912b9151f22f6f1e270.jpg?resize=1024x683',
        header: 'Modern Font 1',
        user: {
          name: 'George W.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$12.99',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/7071073/file/original-5d3fb734b434fea4d225fb59f1d649e2.jpg?resize=1024x682',
        header: 'Classic Font 2',
        user: {
          name: 'Hannah Y.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: '$17.99',
      },
    ],
  },
  {
    category: 'Freebies',
    icon: <FreebieesSVG  stroke={fillColor}/>,
    styles: 'grid lg:grid-cols-3',
    cards: [
      {
        picture: 'https://cdn.dribbble.com/userupload/10494043/file/original-6dc2f312f9fbe25dff4b4f104e64eeff.png?resize=1024x768',
        header: 'Freebie 1',
        user: {
          name: 'Liam J.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: 'Free',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/15065187/file/original-7bee788a98b03d4ec8fa7c6d208d59d5.jpg?resize=1024x768',
        header: 'Freebie 2',
        user: {
          name: 'Liam J.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: 'Free',
      },
      {
        picture: 'https://cdn.dribbble.com/userupload/14819519/file/original-4e2e78e8304523503353a5ac0d148db2.jpg?resize=1024x768',
        header: 'Freebie 3',
        user: {
          name: 'Mia P.',
          picture: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        price: 'Free',
      },
    ],
  },
];


export { homepageData, categories };
